import { render } from "./CStatistic.vue?vue&type=template&id=a41e5e24&scoped=true"
import script from "./CStatistic.vue?vue&type=script&lang=js"
export * from "./CStatistic.vue?vue&type=script&lang=js"

import "./CStatistic.vue?vue&type=style&index=0&id=a41e5e24&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41e5e24"],['__file',"src/views/h5/luqiao/home/sichuanluqiao/CStatistic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a41e5e24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a41e5e24', __exports__)) {
    api.reload('a41e5e24', __exports__)
  }
  
  module.hot.accept("./CStatistic.vue?vue&type=template&id=a41e5e24&scoped=true", () => {
    api.rerender('a41e5e24', render)
  })

}


export default __exports__